import { Component } from '@angular/core';
import * as moment from 'moment';
import { WorkingTimeSchemaService } from '../working-time-schema.service';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import {
  getAllUserCalendars,
  getBaseCalendarByUser,
  getCalendarDic,
  getNonWorkingDays
} from '../store/selectors/calendars.selectors';
import { CalendarsOperations } from '../store/reducers/calendars-operation';
import { IAppState } from 'app/IAppState';

enum EWeekDay {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday
}

const NON_WORKING_DAY_CLASS = 'bmc-non-working-day';
const EDITED_DAYS_CLASS = 'bmc-edited-days';
const EDITED_HOURS_CLASS = 'bmc-edited-hours';

@Component({
  selector: 'working-time-schema-viewer',
  templateUrl: 'working-time-schema-viewer.component.html',
  styleUrls: ['working-time-schema-viewer.component.scss']
})

export class WorkingTimeSchemaViewerComponent {
  public bsInlineValue = new Date();
  public selectedDay = null;
  public showCalendar = false;
  public showDetail = false;
  public calendarDic = {};
  public weekDaysSchedule: {[key: string]: Array<IBaseCalendarTime>} = {};
  public bsConfig = {
    showWeekNumbers: false
  };
  public selectedDateDetail = '';

  public dateCustomClasses = [];
  private _calendarSubscription: Subscription;
  private _calendarDicSubscription: Subscription;
  private _nonWorkingDaysSubscription: Subscription;
  private listTimeOut: any[] = [];
  public editedHours: boolean = false;

  constructor(private _workingTimeSchemaService: WorkingTimeSchemaService, private _store: Store<IAppState>) {
  }

  ngAfterViewInit() {
    this._calendarSubscription = this._store.pipe(select(getBaseCalendarByUser)).subscribe((baseCalendar: IBaseCalendar) => {
      this._setBaseCalendar(baseCalendar);
    });
    this._calendarDicSubscription = this._store
      .pipe(select(getCalendarDic))
      .subscribe((calendarDic: { [key: string]: IWorkingTimeSchema }) => {
        this.calendarDic = calendarDic;
      });
    this._nonWorkingDaysSubscription = this._store.pipe(select(getAllUserCalendars)).subscribe((list: IWorkingTimeSchema[]) => {
      this._setCustomCalendar(list);
    });

  }

  public setSelectedDay(day) {
    this.selectedDay = day;
  }

  ngOnDestroy() {
    if (this._calendarSubscription) {
      this._calendarSubscription.unsubscribe();
    }
    if (this._calendarDicSubscription) {
      this._calendarDicSubscription.unsubscribe();
    }

    this.listTimeOut.forEach(timeOut => clearTimeout(timeOut));
  }


  private _setBaseCalendar(calendar: IBaseCalendar) {
    this.weekDaysSchedule = {};
    _.forEach(calendar.calendarByDays, (weekday: IBaseCalendarDay) => {
      if (weekday.isWorking) {
        this.weekDaysSchedule[weekday.weekDay] = weekday.workTimes;
      }
    });
    this.bsConfig['daysDisabled'] = [];
    _.each(calendar.calendarByDays, (day: IBaseCalendarDay) => {
      if (!day.isWorking) {
        this.bsConfig['daysDisabled'].push(EWeekDay[day.weekDay]);
      }
    });
    this.dateCustomClasses = [];
    _.each(calendar.calendarByRange, (day: ICalendarRange) => {
      if (!day.isWorking) {
        this.dateCustomClasses.push({ date: new Date(day.dateFrom), classes: [EDITED_DAYS_CLASS] });
      } else {
        const customClass = EDITED_HOURS_CLASS + '__' +day.dateFrom.toString();
        this.dateCustomClasses.push({ date: new Date(day.dateFrom), classes: [EDITED_HOURS_CLASS, customClass] });
        this.weekDaysSchedule[day.dateFrom] = day.workTimes;
      }
    });
    this.showCalendar = false;
    this.listTimeOut.push(setTimeout(() => {
      this.showCalendar = true;
    }));
  }

  public onOver(ev) {
    this.selectedDateDetail = null;
    this.editedHours = false;
    if(_.includes(ev.target.classList, 'bmc-edited-hours')) {
      const selectedDate = ev.target.classList[1].substr(18);
      this.selectedDateDetail = selectedDate;
      this.showDetail = true;
      this.editedHours = true;
    } else if(_.includes(ev.target.classList, 'disabled') || _.includes(ev.target.classList, 'bmc-edited-days')) {
      this.showDetail = false;
    } else {
      this.selectedDateDetail = (EWeekDay[ev.target.parentElement['cellIndex']]);
      this.showDetail = true;
    }
  }

  public onLeave() {
    this.showDetail = false;
  }

  private _setCustomCalendar(customCalendarList: Array<IWorkingTimeSchema>) {
    this.dateCustomClasses = [];
    _.each(customCalendarList, (workingTimeSchema: IWorkingTimeSchema) => {
      const dateClass = workingTimeSchema.isWorking ? EDITED_HOURS_CLASS : EDITED_DAYS_CLASS;
      _.each(CalendarsOperations.getRangeOfDates(workingTimeSchema.fromDate, workingTimeSchema.toDate), (date) => {
        this.dateCustomClasses.push({ date: new Date(date), classes: [date, dateClass] });
      });
    });
    this.showCalendar = false;
    this.listTimeOut.push(setTimeout(() => {
      this.showCalendar = true;
    }));
  }
}
